import { render, staticRenderFns } from "./InviteSalesUser.vue?vue&type=template&id=614b646a&"
import script from "./InviteSalesUser.vue?vue&type=script&lang=js&"
export * from "./InviteSalesUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports